// extracted by mini-css-extract-plugin
export var borderStyle = "sticky_nav-module--borderStyle--ODbR+";
export var dropShadowStyle = "sticky_nav-module--dropShadowStyle--lv0R+";
export var headingPaddingStyle = "sticky_nav-module--headingPaddingStyle--rtfst";
export var offsetTopStyle = "sticky_nav-module--offsetTopStyle--c2mIz";
export var stickyNavInnerStyle = "sticky_nav-module--stickyNavInnerStyle--fENxP";
export var stickyNavWrapperStyle = "sticky_nav-module--stickyNavWrapperStyle--P0McO";